import { errorNotification } from './Notifications'

export const handleRequestError =
  (err, alert = true) =>
  async (dispatch, getState, api) => {
    if (alert) {
      dispatch(errorNotification(err))
    }
  }
